export enum StreamEntityType {
    Packs = 'packs',
    Repacks = 'repacks',
    Samples = 'samples',
    Custom = 'custom',
}
